import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Search, orderStatus, Filter, Export, paymentStatus, CancelledInvoice, CancelledInvoiceList } from '../../../Constant';
import { getCustomers, getCustomersRole, viewCancelInvoice, restoreInvoice } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import moment from 'moment';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import Typeahead from '../../../CommonElements/TypeAhead';

const CancelInvoiceContainer = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const [invoiceLists, setInvoiceList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
        customer: '',
        start: '',
        end: '',
        orderStatus: '',
        paymentStatus: '',
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [apiCustomer, setapiCustomer] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const isSearched = useRef(null);
    const isOrderstatus = useRef(null);
    const isPaymentstatus = useRef(null);
    const [isCustomer, setIsCustomer] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });

    const orderStatusOptions = [
        { value: "pending", label: "Pending" },
        { value: "processed", label: "Processed" }
    ]
    const payStatusOptions = [
        { value: "pending", label: "Pending" },
        { value: "partially_paid", label: "Partially Paid" },
        { value: "paid", label: "Paid" }

    ]

    useEffect(() => {
        fetchInvoice(1);
        customerData();
    }, []);

    useEffect(() => {
        const customerOptions = apiCustomer.map((customer) => ({
            value: customer.id,
            label: customer.name,
        }));
        setCustomerOptions(customerOptions);
    }, [apiCustomer]);

    const invoiceColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            width: '60px'
        },
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            center: true,
            width: '60px'
        },
        {
            name: <H4>Invoice No</H4>,
            id: 'invoice_no',
            selector: row => row.InvoiceNo,
            sortable: true,
            wrap: true,
            width: '110px'
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Customer,
            sortable: true,
            width: '110px',
            wrap: true
        },
        {
            name: <H4>Customer Id</H4>,
            id: 'subscriber_id',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                    <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                        {row.Sub}
                    </Link> : row.Sub,
            sortable: true,
            wrap: true,
            width: '110px',
        },
        {
            name: <H4>Bin Id</H4>,
            id: 'bin_id',
            selector: row => row.BinId,
            sortable: true,
            width: '150px'
        },
        {
            name: <H4>Subscribed Plans</H4>,
            id: 'balance',
            selector: row => <span className='text-danger' style={{ fontWeight: 'bold' }}>{authState.currency} {row.balance}</span>,
            sortable: true,
            width: '110px',
        },
        {
            name: <H4>Plan Start Date</H4>,
            id: 'invoice_date',
            selector: row => row.InvoiceDate,
            sortable: true,
            width: '150px'
        },
        {
            name: <H4>Invoice Type</H4>,
            id: 'invoice_type',
            selector: row => row.con_type,
            sortable: true,
            width: '110px'
        },
        {
            name: <H4>Payment Status</H4>,
            selector: row => (<span
                className={`badge badge-${row.payment_status}`} >
                {row.payment_status}
            </span>
            ),
            width: '135px'
        },

        // {
        //     name: <H4>Invoice Date</H4>,
        //     id: 'invoice_date',
        //     selector: row => row.InvoiceDate,
        //     sortable: true,
        //     width: '150px'
        // },

        // {
        //     name: <H4>Order Status</H4>,
        //     selector: row => (<span
        //         className={`badge badge-${row.order_status}`} >
        //         {row.order_status}
        //     </span>
        //     ),
        //     width: '135px'
        // },
    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchInvoice(currentPage, perPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleChange = (selectedOption) => {
        setIsCustomer(selectedOption);
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const customerData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
        if (data.status === true) {
            setapiCustomer(data.data);
        } else {
            handleApiError(data.status);
        }
    };

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handlePaymentClick = () => {
            SweetAlert.fire({
                title: 'Confirm restore?',
                // text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setLoading(true);
                if (result.value) {
                    const orderIdRes = { order_id: row.id }
                    const restoreApi = await postClientUrlWithToken(authState.apiUrl, restoreInvoice, orderIdRes);
                    if (restoreApi.status === 200) {
                        if (restoreApi.data.status === true) {
                            SweetAlert.fire(
                                'Restored!',
                                'Your file has been restored.',
                                'success'
                            );
                            fetchInvoice(currentPage, perPage, filters.search, filters.customer, filters.start, filters.end, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
                        } else {
                            setLoading(false)
                            toast.error(restoreApi.data.message);
                        }
                    } else {
                        handleApiError(restoreApi.status);
                    }
                }
                setLoading(false);
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => handlePaymentClick()}>Restore</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };

    const fetchInvoice = async (page, size = perPage, searchKey = "", customer_id = '', start_date = '', end_date = '', orderStatus = '', payment_status = '', sortBy = '', sortOrder = '') => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 && viewCancelInvoice +
            `?page=${page}&page_length=${size}&search=${searchKey}&customer_id=${customer_id}
            &start_date=${start_date}&end_date=${end_date}&status=${orderStatus}&payment_status=${payment_status}
            &sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setInvoiceList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Sub: <span>{e.subscriber_id}</span>,
                    BinId: e.bin_id,
                    Customer: e.customer_name,
                    Amount: e.amount,
                    balance: e.balance,
                    InvoiceDate: e.invoice_date,
                    InvoiceNo: e.invoice_number,
                    Status: e.status,
                    order_status: e.order_status,
                    id: e.id,
                    customer_id: e.customer_id,
                    con_type: e.invoice_type,
                    payment_status: e.payment_status,
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };
    const exportInvoiceExcel = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 &&
            viewCancelInvoice + `?export=invoice-cancelled&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&status=${filters?.orderStatus ? filters.orderStatus : ''}
            &paymentStatus=${filters?.paymentStatus ? filters.paymentStatus : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ invoice_number, subscriber_id, customer_name, connection_type, amount, balance, payment_status, invoice_date, order_status }) => ({ Invoice_No: invoice_number, Customer_Id: subscriber_id, Customer: customer_name, Type: connection_type, Amount: amount, Balance: balance, payment_status, Invoice_Date: invoice_date, Order_Status: order_status }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
            XLSX.writeFile(wb, 'Invoice_cancelled.xlsx');
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const exportInvoicePdf = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 &&
            viewCancelInvoice + `?export=invoice-cancelled&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&status=${filters?.orderStatus ? filters.orderStatus : ''}
            &paymentStatus=${filters?.paymentStatus ? filters.paymentStatus : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ invoice_number, subscriber_id, customer_name, connection_type, amount, balance, payment_status, invoice_date, order_status }) => ({ invoice_number, subscriber_id, customer_name, connection_type, amount, balance, payment_status, invoice_date, order_status }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Invoice No", "Customer Id", "Customer", "Type", "Amount", "Balance", "Payment Status", "Invoice Date", "Order Status"];
            const rows = dataToExport.map(({ invoice_number, subscriber_id, customer_name, connection_type, amount, balance, payment_status, invoice_date, order_status }) => [invoice_number, subscriber_id, customer_name, connection_type, amount, balance, payment_status, invoice_date, order_status]);
            doc.autoTable({
                head: [columns],
                body: rows
            });
            doc.save("Invoice_Cancelled.pdf");
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const handlePageChange = page => {
        fetchInvoice(page, perPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchInvoice(page, newPerPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const handleFilter = async (e) => {
        e.preventDefault();
        const search = isSearched.current.value;
        const customerId = isCustomer?.value;
        const orderStatus = isOrderstatus.current.value;
        const paymentStatus = isPaymentstatus.current.value;
        const start = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        setFilters({
            search,
            customerId,
            start,
            end,
            orderStatus,
            paymentStatus
        });
        fetchInvoice(1, perPage, search, customerId, start, end, orderStatus, paymentStatus);
    };


    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={CancelledInvoice} parent="Billing" title={CancelledInvoice} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -35px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{CancelledInvoiceList}</H3>
                    <div>
                        <CardBody className="dropdown-basic" style={{ borderRadius: '5px' }}>
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4 button-addsale">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportInvoiceExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportInvoicePdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </CardBody>
                    </div>
                </CardHeader>
                <CardBody>
                    <span className=''>
                        <Form className="needs-validation" noValidate onSubmit={handleFilter}>

                            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                                <Col sm="12" md='5' lg='2'>
                                    <input name='search' className="form-control" placeholder={Search} id="validationCustom01" type="text" ref={isSearched}
                                    />
                                </Col>
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DatePicker
                                            className="form-control digits w-100"
                                            selectsRange={true}
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            isClearable={true}
                                            monthsShown={2}
                                            popperPlacement="bottom"
                                            calendarClassName='parallel-calendar'
                                            placeholderText='Select Date Range'
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </div>
                                </Col>
                                <Col sm="12" md="5" lg="2" className="form-element">
                                    <Typeahead
                                        options={customerOptions}
                                        onChange={handleChange}
                                        placeholder="Customer..."
                                    />
                                </Col>
                                {/* <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={isOrderstatus}>
                                        <option value="">{orderStatus}</option>
                                        {orderStatusOptions.map((option, index) => (

                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </Col> */}
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={isPaymentstatus}>
                                        <option value="">{paymentStatus}</option>
                                        {payStatusOptions.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                    <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={invoiceColumns}
                            data={invoiceLists}
                            progressPending={loading}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment >
    );
};

export default CancelInvoiceContainer;